import React from "react";
import useElementOnScreen from "../hooks/useElementOnScreen";
interface LazyRendererProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  root?: Element;
  rootMargin?: string;
  threshold?: number;
  onVisible?: (isVisible: boolean) => void;
}
const LazyRenderer: React.FC<LazyRendererProps> = ({
  children,
  fallback,
  root,
  rootMargin,
  threshold,
  onVisible,
}) => {
  const { ref, isVisible } = useElementOnScreen({
    root: root || null, //consider  entire viewport
    rootMargin: rootMargin || "0px",
    threshold: threshold || 0,
    onVisible,
  });

  return (
    <div ref={ref as React.RefObject<HTMLDivElement>}>
      {isVisible ? children : fallback}
    </div>
  );
};

export default LazyRenderer;
